import type { ComponentObjectPropsOptions } from "vue";

export function propsFactory<T = any>() {
	return <K extends ComponentObjectPropsOptions<T>>(props: K) => props;
}

export function cleanProps<T extends Record<string, unknown>>(
	props: T,
	allowed: string[]
): Partial<T> {
	const allowedSet = new Set(allowed);

	const cleanedProps = { ...props } as Partial<T>;
	for (const key in cleanedProps) {
		if (!allowedSet.has(key) || cleanedProps[key] === undefined) {
			delete cleanedProps[key];
		}
	}

	return cleanedProps;
}
